import { Sidebar } from 'primereact/sidebar';

/**
 * Бічна панель зі сталою структурою: заголовок — тіло, що прокручується, —
 * закріплені знизу дії.
 *
 * Раніше кнопки «Оплатити» / «Внести готівку» їхали разом із вмістом і на
 * телефоні опинялися за межею екрана; тепер вони завжди видимі внизу
 * (з урахуванням жестової смуги iPhone).
 */
const Drawer = ({
    visible,
    onHide,
    title,
    position = 'right',
    footer,
    flush = false,
    className = '',
    children,
}) => (
    <Sidebar
        visible={visible}
        position={position}
        onHide={onHide}
        blockScroll
        className={`rc-drawer ${className}`.trim()}
        header={title ? <span className="rc-drawer__title">{title}</span> : undefined}
    >
        <div className={`rc-drawer__body ${flush ? 'rc-drawer__body--flush' : ''}`.trim()}>
            {children}
        </div>
        {footer && <div className="rc-drawer__footer">{footer}</div>}
    </Sidebar>
);

export default Drawer;
